import { ComponentChild, h } from 'preact'
import Checkbox from '../../ui-components/Checkbox'
import Phrase from '../../../libs/translationsUtils/phrase'

export type sourcesWithExternalTypes = 'community' | 'knowledge_base' | 'zendesk' | 'salesforce' | 'skilljar' | 'freshdesk'

export type SourceTabsType = Array<{
  key: sourcesWithExternalTypes,
  isEnabled: boolean
}>

interface Props {
  title: ComponentChild,
  updateSourceTabs: (tab: SourceTabsType) => void,
  tabs: SourceTabsType,
  counts: {
    community: number,
    zendesk: number, 
    salesforce: number, 
    skilljar: number,
    freshdesk: number,
    totalTopics: number
  }
}

const labelMapping = {
  'community': <Phrase m='Forum' p='nav.title.community' />,
  'knowledge_base': <Phrase m='Common' p='advanced.search.filter.knowledgebase.category' />,
  'zendesk': <Phrase m='Forum' p='federated.search.zendesk' />,
  'salesforce': <Phrase m='Forum' p='federated.search.salesforce' />,
  'skilljar': <Phrase m='Forum' p='federated.search.skilljar' />,
  'freshdesk': <Phrase m='Forum' p='federated.search.freshdesk' />
}

const SourceTabs = ({ tabs, updateSourceTabs, title, counts }: Props) => {
  const updateTab = (tab: {
    key: sourcesWithExternalTypes,
    isEnabled: boolean
  }, idx: number) => {
    tabs[idx].isEnabled = !tab.isEnabled
    updateSourceTabs(tabs)
  }
  return (
    <div className='instant-search__source-type-filter'>
      <span className='instant-search__filter-title'>{title}</span>
      {
        counts.totalTopics === 0 ? (
          <div className='instant-search__filter-no-results'><Phrase p='No results' m='Control'/></div>
        ) : (
          <ul>
            {tabs.map((tab, idx) => {
              return (
                <li key={tab.key} className='instant-search__filter-list-item instant-search__source-filter-item'>
                  <div className={`instant-search-filter__label-wrapper ${tab.isEnabled ? 'refined' : ''}`}>
                    <Checkbox
                      label={labelMapping[tab.key]}
                      onUpdate={() => updateTab(tab, idx)}
                      qaClasses={'topic-type-checkbox'}
                      checked={tab.isEnabled}
                    />
                  </div>
                </li>
              )}
            )}
          </ul>
        )
      }
    </div>
  )
}

export default SourceTabs
